import { render, staticRenderFns } from "./RunTags.vue?vue&type=template&id=529efd86&scoped=true&"
import script from "./RunTags.vue?vue&type=script&lang=js&"
export * from "./RunTags.vue?vue&type=script&lang=js&"
import style0 from "./RunTags.vue?vue&type=style&index=0&id=529efd86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529efd86",
  null
  
)

export default component.exports